import { SetStateAction } from "react";
import { AnswerSetResult } from "../../../store/viewmodels/AnswerSetViewModel";
import { Itemset } from "../../../store/viewmodels/ItemsetViewModel";
import { Student } from "../../../store/viewmodels/StudentViewModel";
import { Task } from "../../../store/viewmodels/TaskViewModel";
import { ResultItem } from "./ResultItem";

interface ResultsItemsetListProps {
    currentTask: Task,
    setSelectedAnswerset: React.Dispatch<SetStateAction<AnswerSetResult>>
    student?: Student,
}

export function ResultsItemsetList(props: ResultsItemsetListProps): JSX.Element {
    let results: AnswerSetResult[] = [];
    let itemsetList: JSX.Element[] = [];

    if (props.student !== undefined) {
        if (props.student.results !== undefined) {
            results = props.student.results;

            for (let r: number = 0; r < results.length; r++) {
                for (let i: number = 0; i < props.currentTask.itemsets.length; i++) {
                    let itemset: Itemset = props.currentTask.itemsets[i];
                    let result = results[r];

                    if (!result) { console.log("result === null"); continue; }
                    if (!result.itemset) { console.log("itemset === null"); continue; }

                    if (results[r].itemset.id === itemset.id) {
                        itemsetList.push(<ResultItem key={"ResultItem_" + results[r].end_time + "_" + i} answerSet={results[r]} setSelectedAnswerset={props.setSelectedAnswerset} />)
                    }
                }
            }
        }
    }

    if (itemsetList.length === 0) return <div>{"Ei vielä vastauksia."}</div>;

    return (
        <div className="max-w-full xl:max-w-3/4 4xl:max-w-1/2 flex flex-wrap">
            {itemsetList}
        </div>);
}